package fr.manyverse.app.infrastructure.monitoring

import co.touchlab.kermit.Logger
import fr.manyverse.app.AppConfig
import fr.manyverse.app.AppLogger

private const val TAG = "Monitoring"

private var activeCrashReporter: CrashReporter? = null

/**
 * Démarre la remontée des crashs et des logs vers Sentry.
 *
 * À appeler une seule fois, le plus tôt possible dans chaque point d'entrée natif
 * (Application Android, `iOSApp.init`, `main` desktop et web). Ce démarrage se fait hors de
 * Koin, qui n'est lancé qu'à la première composition : un crash survenu avant serait perdu.
 *
 * Sans `SENTRY_DSN` (build local non configuré), rien n'est envoyé et les logs restent
 * uniquement dans la sortie native de la plateforme.
 *
 * @param isDebugBuild range les événements dans l'environnement Sentry `development` plutôt
 *   que `production`, pour pouvoir les filtrer.
 */
fun initMonitoring(isDebugBuild: Boolean) {
    if (activeCrashReporter != null) return

    if (AppConfig.SENTRY_DSN.isBlank()) {
        AppLogger.warn(TAG, "SENTRY_DSN absent : remontée des erreurs désactivée")
        return
    }

    val crashReporter = createCrashReporter()
    crashReporter.start(
        CrashReporterConfig(
            dsn = AppConfig.SENTRY_DSN,
            release = "manyverse@${AppConfig.APP_VERSION}",
            environment = if (isDebugBuild) "development" else "production"
        )
    )
    Logger.addLogWriter(CrashReportingLogWriter(crashReporter))
    activeCrashReporter = crashReporter
}

/** Reporter démarré par [initMonitoring], exposé à Koin ; inerte si Sentry n'est pas actif. */
fun currentCrashReporter(): CrashReporter = activeCrashReporter ?: NoOpCrashReporter
